import { copyToClipboard } from "./clipboard";
import { ActionOption } from "../utils";

export function getYouTubeCopyLinkOption(ytVideoId: string): ActionOption {
  return {
    label: "Copy video link",
    onClick: () =>
      copyToClipboard(`https://www.youtube.com/watch?v=${ytVideoId}`),
  };
  //`https://www.youtube.com/watch?v=${source.details!.videoId}`
}
